export const STRING_FILTER = 'agTextColumnFilter';
export const NUMERIC_FILTER = 'agNumberColumnFilter';
export const DATE_FILTER = 'agDateColumnFilter';
